import { SaleState } from "@/lib/interfaces/sales";

export const getStatusText = (state: SaleState) => {
  switch (state) {
    case SaleState.Open:
      return "Offen";
    case SaleState.Draft:
      return "Entwurf";
    case SaleState.Completed:
      return "Gebucht";
    case SaleState.Cancelled:
      return "Storniert";
    case SaleState.Closed:
      return "Geschlossen";
    case SaleState.Lost:
      return "Verloren";
    default:
      return state;
  }
};
